import { useCallback } from 'react';
import { useAddress, useServiceLevels } from 'src/graphql';
import { NullableDeepPartial } from 'src/graphql/types';
import { AddressRaw } from 'src/types/api-types';

export const useUpdateAssociatedSite = (
  address?: NullableDeepPartial<AddressRaw>,
  conversationId?: string,
) => {
  const { updateAddress } = useAddress(address?.addressId || '');
  const { serviceLevelOptions } = useServiceLevels(
    address?.partner?.id ?? address?.partnerId,
  );

  return useCallback(
    async (values: { serviceLevel?: { id: string }; accountManager?: { id: string } }) => {
      if (!address) return;

      const hasServiceLevel = values.serviceLevel !== null && values.serviceLevel !== undefined;
      const hasAccountManager =
        values.accountManager !== null && values.accountManager !== undefined;

      if (hasServiceLevel) {
        const selectedOption = serviceLevelOptions.find(
          (opt) => opt.id === values.serviceLevel?.id,
        );

        const addressUpdate: NullableDeepPartial<AddressRaw> = {
          ...address,
          clientActivatedMembership: values.serviceLevel?.id,
          platformSlaId: selectedOption?.platformSlaId ?? null,
          ...(hasAccountManager
            ? {
                ownerId: values.accountManager?.id,
                platformUser: values.accountManager,
              }
            : {}),
        };

        await updateAddress(addressUpdate, conversationId);
        return;
      }

      if (hasAccountManager) {
        return updateAddress(
          {
            ...address,
            ownerId: values.accountManager?.id,
            platformUser: values.accountManager,
          },
          conversationId,
        );
      }
      return undefined;
    },
    [
      address,
      conversationId,
      updateAddress,
      serviceLevelOptions,
    ],
  );
};
